import MessageConstants from '../constants/messages';

const FormValidator = {
  install(App: any) {
    App.config.globalProperties.deletionAlert = (deletable: string, extraMessage?: string): any => {
      let text = `Are you sure you want to delete this ${deletable}?`
      if (!!extraMessage) { text = text + ' ' + extraMessage }
      return App.config.globalProperties.$swal({
        title: 'Confirm deletion',
        text: text,
        icon: 'warning',
        confirmButtonColor: '#c94b3b',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        focusCancel: true,
      })
    }
  
    App.config.globalProperties.genericError = (url?: string, context?: any): void => {
      if (!!context) {
        console.error("error: ", context);
      }
      window.App.loader('hide');
      App.config.globalProperties.$swal('Oops...', MessageConstants.GENERIC_ERROR, 'error').then(() => {
        if (url) { window.location.href = url; }
      });
    }

    App.config.globalProperties.baseErrorHandler = (e: any, url?: string, context?: any): void => {
      if (!!context) {
        console.error("error: ", context);
      }
      window.App.loader('hide');

      if (e.clientMessageHandled) {
        return;
      } else {
        console.error(e);
        App.config.globalProperties.$swal('Oops...', MessageConstants.GENERIC_ERROR, 'error').then(() => {
          if (url) { window.location.href = url; }
        });
      }
    }
  }
}

export default FormValidator;